import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'help-dialog',
    template: require('./help.dialog.component.html'),
})
export class HelpDialogComponent {
    htmlContent: string = "";

    constructor(public dialogRef: MatDialogRef<HelpDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {

        this.htmlContent = data.content;
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/navigation/help.dialog.component.ts